export default function ReviewConstructor(UserReviewConstructor) {
    'ngInject';

        function Review(backendReviewData) {
            this.createdAt = moment(backendReviewData.DateSent);
            this.userReviews
                = _.chain(backendReviewData.Recipients)
                    .filter((userReview) => userReview.IsCC !== true)
                    .map((userReview) => new UserReviewConstructor(userReview))
                    .value();
        }

        Review.prototype.isEmpty = function() {
            return this.userReviews.length === 0;
        };

        Review.prototype.atLeastOneUserReviewed = function() {
            return _.some(this.userReviews, 'isReviewed');
        };

        Review.prototype.needToShowTripItems = function() {
            return this.userReviews.length === 1;
        };

        Review.prototype.getFirstUserReview = function() {
            return this.userReviews[0];
        };

        return Review;
}



// WEBPACK FOOTER //
// ./src/app/modules/trip/services/tripReviewConstructor.factory.js